import { FeatureIdentifier, Map as MapLib } from "maplibre-gl";
import {
  interactionManager,
  privateDataManager,
  userDataManager,
} from "../globals";
import { FeatureState } from "./map-libre/expressions";
import { setupControls } from "./map-libre/controls/controls";

export class MapManager {
  public map!: MapLib;
  public mapContainer!: HTMLDivElement;

  public init = (mapContainer: HTMLDivElement) => {
    this.mapContainer = mapContainer;

    if (this.map) {
      this.map.remove();
    }

    this.createMap(this.mapContainer);
  };

  /**
   * This is not idempotent. Destroy must be called before calling this method again
   */
  private createMap = (mapContainer: HTMLDivElement) => {
    this.map = new MapLib({
      minZoom: 3,
      maxZoom: 24,
      center: { lng: 132.7, lat: -27.69 },
      zoom: 4,
      hash: true,
      maplibreLogo: false,
      attributionControl: {
        compact: true,
        customAttribution: "© 2024 RenewMap",
      },
      style:
        "https://api.maptiler.com/maps/dca33c26-4f81-4ef8-8b23-02b0d0aeef4e/style.json?key=Js2gJVELHvBM39lXLJ7t",
      container: mapContainer,
    });

    interactionManager.addHoverEffects(this.map);

    setupControls(this.map);

    // load data here after map has initialised
    this.map.on("load", async () => {
      // order of render here is important - things end up on top of each other
      privateDataManager.addPrivateSources(this.map);
      userDataManager.addUserSources(this.map);
    });
  };

  /**
   * Used for setting state on features so that they may be rendered differently upon events (e.g. hover)
   */
  public setFeatureState = (
    identifier: FeatureIdentifier,
    state: Partial<Record<FeatureState, unknown>>,
  ) => {
    this.map.setFeatureState(identifier, state);
  };

  public removeFeatureState = (identifier: FeatureIdentifier) => {
    this.map.removeFeatureState(identifier);
  };

  public getFeatureState = (identifier: FeatureIdentifier) => {
    return this.map.getFeatureState(identifier);
  };
}
